export async function getCurrencyData() {
  const spreadsheetId = "1wEYO9e9AsckvtQN8vazczvnILgcCj-OCI5QnfwFdgd8",
    response = await fetch(
      `https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:json&sheet=NgoaiTe`,
    ),
    result = await response.text(),
    json = JSON.parse(
      result.replace(
        /.*google.visualization.Query.setResponse\({(.*?)}\);?/s,
        "{$1}",
      ),
    );
  let headings = json.table.cols.map((col) => col.label).filter((label) => label);
  let data = json.table.rows.map((item) => {
    let row = {};
    item.c.forEach((cell, idx) => {
      row[headings[idx]] = cell?.v ?? null;
    });
    return row;
  });
  return data;
}

export default async function getData() {
  // https://stackoverflow.com/questions/31765773/converting-google-visualization-query-result-into-javascript-array
  // https://developers.google.com/chart/interactive/docs/dev/implementing_data_source#responseformat
  const spreadsheetId = "1wEYO9e9AsckvtQN8vazczvnILgcCj-OCI5QnfwFdgd8",
    response = await fetch(
      `https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:json`,
    ),
    result = await response.text(),
    json = JSON.parse(
      result.replace(
        /.*google.visualization.Query.setResponse\({(.*?)}\);?/s,
        "{$1}",
      ),
    );

  let headings = json.table.rows[0].c.map((item) => item.v);

  headings = headings.filter((item) => item !== null);

  json.table.rows.shift();

  let data = json.table.rows.map((item) => {
    let row = {};
    item.c.forEach((cell, idx) => {
      row[headings[idx]] = cell?.v ?? null;
    });
    return row;
  });
  /*
    Fields:
    -------------------
    Category
    Name
    Description
    Price
    Publish
    CategoryOrder
    CategoryTranslation
  */

  return data;
}
